<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<mask
		id="mask-facebook-0"
		mask-type="alpha"
		maskUnits="userSpaceOnUse"
		x="7"
		y="2"
		width="10"
		height="20"
	>
		<path
			d="M9.51064 8.68085H7V12H9.51064V22H13.6809V12H16.7021L17 8.68085H13.6809V7.2766C13.6809 6.46808 13.8511 6.17021 14.617 6.17021H17V2H13.8085C10.8298 2 9.51064 3.31915 9.51064 5.82979V8.68085Z"
			fill="white"
		/>
	</mask>
	<g mask="url(#mask-facebook-0)">
		<rect width="24" height="24" fill="currentColor" />
	</g>
</svg>
